/** Shared path constants (avoid circular imports between App and routes). */
export const DASHBOARD_PATH = "/dashboard";
export const LOGIN_PATH = "/login";
export const ADMIN_PATH = "/admin";
